import { useEffect } from 'react';
import { updateMetaTags, SEOData } from '../utils/seo';

export const useSEO = (seo: SEOData) => {
  useEffect(() => {
    updateMetaTags(seo);
  }, [seo.title, seo.description, seo.canonical]);
};
